import { Patient } from 'api/models';

export function getPatientName(patient: Patient) {
  const titles = patient.titles ? `${patient.titles.replace('.', '')}. ` : '';
  return `${titles} ${patient.lastName ?? ''} ${patient.firstName ?? ''}`;
}
